<template>
  <div class="columns is-vcentered">
    <div id="submit-container" class="column is-2">
      <button id="submit" class="button is-success" @click.once="submit">Submit</button>
    </div>
    <div id="not-enough-submissions" class="column is-10 is-hidden">
      <div class="notification is-danger">
        You must nominate at least {{ voteRequirement }} companies to submit this form.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    voteRequirement() {
      return this.$store.state.vote_requirement;
    },
  },
  methods: {
    submit(e) {
      const survey = document.getElementById('survey');
      if (!survey.checkValidity()) throw survey.validationMessage;

      e.preventDefault();

      if (this.$store.state.vote_count < this.voteRequirement) {
        document.getElementById('not-enough-submissions').classList.remove('is-hidden');
        setTimeout(() => {
          document.getElementById('not-enough-submissions').classList.add('is-hidden');
        }, 5000);
        return false;
      }

      // If no errors, reset the progress bar and submit the reuslts.
      this.$store.dispatch('resetVoteCount');

      const formData = new FormData(survey);

      const query = this.http_build_query({
        sheet: this.$store.state.google_sheet_title,
      });

      fetch(`//dj5-api.datajoe.com/api/survey?${query}`, {
        body: formData,
        method: 'post',
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
      });

      return this.$router.push('thankyou');
    },
    http_build_query(jsonObj) {
      const keys = Object.keys(jsonObj);
      const values = keys.map(key => jsonObj[key]);

      return keys
        .map((key, index) => `${key}=${values[index]}`)
        .join('&');
    },
  },
};
</script>
